module.exports = __webpack_public_path__ + "static/media/secondary_racks.38ce79e6.webp";